import ApiService from './ApiService';
import { get } from 'lodash';

class ReferralService extends ApiService {
  constructor(session) {
    super(session);

    this.url = '/referral';
  }

  getReferralUrl = params => {
    return super.get(this.url + '.json', response => get(response, 'referral_url', null));
  }
}

export default ReferralService;
